export const useRecaptcha = (
  siteKey: string | null,
  actionType: string = 'submit'
): Promise<string | null> => {
  return new Promise((resolve) => {
    const { grecaptcha } = window

    if (!grecaptcha || !siteKey) {
      resolve(null)
    } else {
      grecaptcha.ready(async () => {
        try {
          const token = await grecaptcha.execute(siteKey, {
            action: actionType,
          })
          resolve(token)
        } catch (error) {
          resolve(null)
        }
      })
    }
  })
}
